import React from 'react';
import { roundAndFormatPriceAsString } from '@at/formatter-utils/lib/number-utils/number.utils';
import { asFormattedString } from '@at/formatter-utils/lib/number-utils/number.utils';
import * as Styles from './pricing.styled';
import { getPriceVatText } from '../utils/getPriceVatText';
export var FullLeaseOption = function (_a) {
    var termMonths = _a.termMonths, totalMileage = _a.totalMileage, priceMonthly = _a.priceMonthly, priceUpfront = _a.priceUpfront, leaseType = _a.leaseType;
    return (React.createElement(React.Fragment, null,
        priceMonthly && (React.createElement("div", null,
            React.createElement(Styles.VehicleCardPriceText, { as: "p" }, "From"),
            React.createElement(Styles.VehicleCardPriceMonthly, { as: "p", weight: "400", isShowFullLeaseOptionLayout: true }, roundAndFormatPriceAsString(priceMonthly)),
            React.createElement(Styles.VehicleCardPriceText, { as: "p" },
                "Per month ",
                getPriceVatText(leaseType)))),
        priceUpfront && termMonths && totalMileage && (React.createElement(Styles.VehicleCardLeaseOptionDetails, null,
            React.createElement(Styles.VehicleCardLeaseOptionText, null,
                React.createElement(Styles.VehicleLeaseOptionPart, null, roundAndFormatPriceAsString(priceUpfront)),
                ' ',
                "initial payment"),
            ' ',
            React.createElement(Styles.VehicleCardLeaseOptionText, null,
                React.createElement(Styles.VehicleLeaseOptionPart, null, termMonths),
                " month contract"),
            ' ',
            React.createElement(Styles.VehicleCardLeaseOptionText, null,
                React.createElement(Styles.VehicleLeaseOptionPart, null, asFormattedString(totalMileage)),
                ' ',
                "miles p/a"),
            ' '))));
};
